module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-preface001"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There had been "), _c('a', {
    attrs: {
      "id": "page-1"
    }
  }), _vm._v("an underlying sweetness to Mike, I would say that was the essence of him. He had been gorgeous, athletic, bright, deeply good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("He was very confident about his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("He was so introverted in high school that I tried to compensate by being extroverted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("What struck me was his eyes. I couldn’t see the bottom, where they ended. They just kept going.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Mike was superb in the clutch. He probably won at least four games for us on the last shot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("He loved the Band, Dylan, Country Joe & the Fish, the Dead.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("He was not a warm and fuzzy person. I was a little intimidated by him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("It was hard for him to be just one of the group.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("He was an inner cosmonaut. But he wasn’t the slightest bit off. He was one of the cool guys.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Mike was a sweet, vulnerable guy who was trying to find his place. There was an untethered quality. He was lost, good-hearted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("If I had to choose the five sanest people I knew at Duke, Mike would’ve been one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Mike loved"), _c('a', {
    attrs: {
      "id": "page-2"
    }
  }), _vm._v(" to go exploring, to just pick a canyon and follow it to the end.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("He was interested in truth, in the way the human mind worked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Mike liked being outrageous. That was part of his charm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("He is the last person I would’ve expected to develop schizophrenia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("I wouldn’t agree that he’d be the last person to develop schizophrenia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Mike is the most lonesome person I have ever known.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6958c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface001.vue
// module id = 69
// module chunks = 0